module.exports = __webpack_public_path__ + "img/Comercial_Environment.65542295.png";